import React from 'react'
import SpinnerUI from '../../../widgets/output/SpinnerUI'
import ButtonUI from '../../../widgets/action/ButtonUI'
import ErrorMessage2UI from '../../../widgets/form/ErrorMessage2UI'
import SuccessMessageUI from '../../../widgets/form/SuccessMessageUI'

const CommonActionUI = ({context, title, buttonLabel, onClick, submitted, successMsg, errorList}) =>
  <div>
    <SuccessMessageUI successMsg={successMsg} />
    <ErrorMessage2UI errorList={errorList} />
    <div className='g_flex_h'>
      <h4 className='g_m_top_25'>{title}</h4>
      <div className='g_flex_h'>
        <SpinnerUI show={submitted} />
        <div className='g_m_left_50'>
          <ButtonUI label={buttonLabel} onClick={onClick} />
        </div>
      </div>
    </div>
  </div>

export default CommonActionUI
